import { dropdownMapping } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "views/pages/manage/common/constant";
import { fetchAllPostPromisedData, fetchAllPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
// import {
//   getInputParamRegex,
//   multiValuesSearchPasteHandler,
// } from "../../edpOps/constant/student-search";

export const paymentSlabStatusOptions = [
  { label: "Active", value: "ACTIVE" },
  { label: "Inactive", value: "INACTIVE" },
];


export const fetchSlabDetails = async (slabId, {offset = 0, pageSize = 10}) => {
  const response = await fetchAllPromisedData(
    `${endpoint.commissionSlab.create}/${slabId}?page=${offset}&size=${pageSize}`,
  );

  return response || null;
};

export const createConcessionSlab = async (payload) => {
  const response = await fetchAllPostPromisedData(
    `${endpoint.commissionSlab.create}/`,
    payload,
    "post",
  );
  return response?.data || null;
};

export const updateSlabDetails = async (slabId, payload) => {
  const response = await fetchAllPostPromisedData(
    `${endpoint.commissionSlab.create}/${slabId}`,
    payload,
    'put'
  );
  return response;
};
export const updateCommissionSlabRow = async (id, payload) => {
  const response = await fetchAllPostPromisedData(
    `${endpoint.commissionSlab.createSlab}/${id}`,
    payload,
    "put",
  );
  return response || null;
};

export const createCommissionSlabRow = async (payload) => {
  const response = await fetchAllPostPromisedData(
    `${endpoint.commissionSlab.createSlab}`,
    payload,
    "post",
  );
  return response|| null;
};

export const fetchStateAndYearDropdowns = async () => {
  // Fetch state and year dropdowns from master APIs in parallel
  const [yearRes, businessUnitType] = await Promise.all([
    fetchAllPromisedData(endpoint.academic_year.getAllActive),
    dropdownMapping(endpoint.businessType.getAllActiveUnitType, 'businessUnitTypeDispValue', 'id'),
  ]);

  const yearOptions = yearRes.map((item) => ({
    label: item.academicYearDisplayValue,
    value: item.academicYearDisplayValue,
  }));

  return {
    yearOptions,
    businessUnitType
  };
};

export const fetchCommissionSlabDropdowns = async () => {
  // Fetch all required dropdowns in parallel
  const [careerRes, courseAttrRes, courseAttrMappingRes,businessActiveAreas, academicGroupRes] =
    await Promise.all([
      fetchAllPromisedData(endpoint.academic_career.getAllActive),
      fetchAllPromisedData(endpoint.courseAttribute.getAllActive),
      fetchAllPromisedData(
        endpoint.courseAttributeValue.getAllCourseAttributeValue,
      ),
      fetchAllPromisedData(endpoint.businessArea.getAllActiveV2),
      fetchAllPromisedData(endpoint.academic_group.getAllActive),
      
    ]);

  const careerOptions = careerRes.map((item) => ({
    label: item.academicCareerDispValue,
    value: item.id,
  }));
  const courseAttributeOptions = courseAttrRes.map((item) => ({
    label: item.courseAttributeDispValue,
    value: item.id,
    desc: item.courseAttributeDesc,
    key: item.courseAttributeKey,
  }));

  const courseAttributeValueMap = courseAttrMappingRes.map((item) => ({
    label: item.courseAttributeValueDispValue,
    value: item.id,
    desc: item.courseAttributeValueDesc,
    key: item.courseAttributeValueKey,
  }));

  const academicGroupOptions = academicGroupRes.map((item) => ({
    label: item.academicGroupDispValue,
    value: item.id,
  }));

  const extensionBusinessUnits = businessActiveAreas.map((item) => ({
    label: item.businessAreaDispValue,
    value: item.businessAreaDispValue,
  }));

  return {
    careerOptions,
    courseAttributeOptions,
    courseAttributeValueMap,
    academicGroupOptions,
    extensionBusinessUnits,
  };
};
export const searchCommissionSlab = async (payload, page, size) => {
  // API expects offset (page number) and limit (page size)
  const url = `${endpoint.commissionSlab.search}`;
  const response = await fetchAllPostPromisedData(url, {...payload,page,size});

  return response;
};

export const filterBuByButypeAndSubType = (
  businessAreaDropdown = [],
  buTypeDropdown = [],
  buType,
  subType
) => {

  if (!buType) {
    return businessAreaDropdown;
  }

  const buTypeObj = buTypeDropdown.find(
    (item) => item?.label === buType
  );

  let filteredBu = businessAreaDropdown.filter(
    (item) => item?.businessUnitTypeId?.[0] === buTypeObj?.value
  );

  if (subType) {
    filteredBu = filteredBu.filter(
      (item) => item?.franchiseSubType === "F+EC"
    );
  }

  return filteredBu;
};